export default __webpack_public_path__ + "static/media/PEN_Xmas2021_GiftGuide_Page_18.2f6f4bb9.jpg";